import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "@/core/services/url-handler.service";

const PayoutsApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  /**
   * Get payout requests list
   * @param params - { status, provider, customerCode, customerEmail, page, size }
   * @returns {*}
   */
  getPayoutRequests(params) {
    return Vue.axios.get(this.URL + `e8dc6f52/admin/payout/requests`, {
      params: { ...params, ignoreCountryId: true },
      ignoreCountryId: true
    });
  },

  /**
   * Get payout request detail by id
   * @param id - payout request id
   * @returns {*}
   */
  getPayoutRequestById(id) {
    return Vue.axios.get(this.URL + `e8dc6f52/admin/payout/requests/${id}`, {
      ignoreCountryId: true
    });
  },

  /**
   * Approve a payout request
   * @param id - payout request id
   * @param reason - optional admin note
   * @returns {*}
   */
  approvePayoutRequest(id, reason = null) {
    const body = reason ? { reason } : {};
    return Vue.axios.post(this.URL + `e8dc6f52/admin/payout/requests/${id}/approve`, body, {
      ignoreCountryId: true
    });
  },

  /**
   * Reject a payout request
   * @param id - payout request id
   * @param reason - rejection reason (required)
   * @returns {*}
   */
  rejectPayoutRequest(id, reason) {
    return Vue.axios.post(
      this.URL + `e8dc6f52/admin/payout/requests/${id}/reject`,
      { reason },
      {
        ignoreCountryId: true
      }
    );
  },

  /**
   * Retry a failed/reversed payout request
   * @param id - payout request id
   * @returns {*}
   */
  retryPayoutRequest(id) {
    return Vue.axios.post(
      this.URL + `e8dc6f52/admin/payout/requests/${id}/retry`,
      {},
      {
        ignoreCountryId: true
      }
    );
  },

  /**
   * Sync payout request state from provider
   * @param id - payout request id
   * @returns {*}
   */
  syncPayoutRequest(id) {
    return Vue.axios.post(
      this.URL + `e8dc6f52/admin/payout/requests/${id}/sync`,
      {},
      {
        ignoreCountryId: true
      }
    );
  },

  /**
   * Bulk approve payout requests
   * @param ids - array of payout request ids
   * @returns {*}
   */
  bulkApprove(ids) {
    return Vue.axios.post(
      this.URL + `e8dc6f52/admin/payout/requests/bulk-approve`,
      { ids },
      { ignoreCountryId: true }
    );
  },

  /**
   * Bulk reject payout requests
   * @param ids - array of payout request ids
   * @param reason - rejection reason
   * @returns {*}
   */
  bulkReject(ids, reason) {
    return Vue.axios.post(
      this.URL + `e8dc6f52/admin/payout/requests/bulk-reject`,
      { ids, reason },
      { ignoreCountryId: true }
    );
  }
};

export default PayoutsApiService;
